import createDataContext from './createDataContext';
import * as actions from './actions/crewRequestActions';
import { reducer, initialState } from './reducers/crewRequestReducer';

export const { Context: CrewRequestContext, Provider } = createDataContext(
  reducer,
  actions,
  initialState
);
